import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import Form from 'antd/lib/form';
import { allocationStatusT, allocationTypeT, accountRoles, contractType } from '../../../common/enums';
import { DocumentsCollapse } from '../../../common/components/data-display';
import {
  formatDateTime,
  formatMonthsCount,
  formatMonthsQuantity,
  currencyFormatter,
  percentageFormatter,
} from '../../../common/utils/helpers';

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};


const LoansList = props => {
  const t = props.t
  const loans = props.loans.map((loan, index) => {
    return (
      <div key={loan.id} >
        <Form.Item {...formItemLayout} label={t('Meno priezvisko')}>
          <span>{loan.loanerName}</span>
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('ID pôžičky')}>
          <Link to={`/admin/loans/${loan.LoanId}`}>{loan.LoanId}</Link>
        </Form.Item>
        <Form.Item  {...formItemLayout} label={t('Alokovaná suma')}>
          <span>{currencyFormatter(loan.amount)}</span>
        </Form.Item>
        <Form.Item {...formItemLayout} label={t('Úroková sadzba')}>
          <span>{percentageFormatter(loan.interest)}</span>
        </Form.Item>
        <br />
        {index + 1 < props.loans.length && <hr />}
      </div>
    )
  })
  return (
    <div>{loans}</div>
  );
}

@translate()
export default class AllocationDetail extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    allocation: PropTypes.object,
    token: PropTypes.string.isRequired,
  };

  componentDidMount() {
    console.log(this.props.allocation.investments.length);
  }

  render() {
    const { allocation, token, t } = this.props;

    return (
      <div>
        <Form>
          <Form.Item {...formItemLayout} label={t('ID')}>
            <span>{allocation.id}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Meno investora')}>
            <Link to={`/admin/accounts/${allocation.accountId}/profile`}>{allocation.accountName}</Link>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Typ investície')}>
            <span>{allocationTypeT[allocation.type]}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Výška alokácie')}>
            <span>{currencyFormatter(allocation.amount)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Alokované prostriedky')}>
            <span>{currencyFormatter(allocation.amountInvested)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Splatené prostriedky')}>
            <span>{currencyFormatter(allocation.amountPaidBack)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Úrok')}>
            <span>{percentageFormatter(allocation.interest)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Stav')}>
            <span>{allocationStatusT[allocation.status]}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Dĺžka investície')}>
            <span>
              {formatMonthsCount(allocation.termMonths)}{' '}
              {formatMonthsQuantity(allocation.termMonths)}
            </span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Vytvorené')}>
            <span>{formatDateTime(allocation.createdAt)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Upravené')}>
            <span>{formatDateTime(allocation.updatedAt)}</span>
          </Form.Item>
        </Form>

        {allocation.investments.length > 0 ?
          <Form.Item {...formItemLayout} label={t('Pôžičky:')}>
            <LoansList loans={allocation.investments} t={t} />
          </Form.Item> : null}

        <DocumentsCollapse
          contracts={allocation.allocationBought ? allocation.contracts.filter(contract => contract.type === contractType.ALLOCATION_TRANSFER) : allocation.contracts}
          token={token}
          accountRole={accountRoles.CREDITOR}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocation-management/components/AllocationDetail.js